// The brand fonts as one style sheet with every font file inlined (data URLs), for the PNG/PDF export: the image library can't
// fetch Adobe Fonts itself. Fetched once and kept; an empty string means "tried and failed" (the export then falls back to the
// print dialog). Ported unchanged from the original pages.
const KIT_CSS = 'https://use.typekit.net/srl7etm.css';

/* Safely convert an ArrayBuffer to base64 using chunked fromCharCode (avoids call-stack overflow on large font files). */
function _bufToB64(buf: ArrayBuffer){
  const bytes = new Uint8Array(buf);
  let out = '';
  const CHUNK = 8192;
  for(let i = 0; i < bytes.length; i += CHUNK)
    out += String.fromCharCode(...bytes.subarray(i, i + CHUNK));
  return btoa(out);
}

let _fontCSS: string | null = null;
export async function embeddedFontCss(): Promise<string> {
  if(_fontCSS !== null) return _fontCSS;
  try{
    const cssResp = await fetch(KIT_CSS, {mode:'cors'});
    let css = await cssResp.text();

    /* collect unique font-file URLs */
    const urls = [...new Set(
      [...css.matchAll(/url\("([^"#\s]+)"/g)].map(m => m[1]!)
    )];

    /* fetch every font file in parallel */
    const settled = await Promise.allSettled(
      urls.map(async url => {
        const r = await fetch(url, {mode:'cors'});
        if(!r.ok) throw new Error('http '+r.status);
        const buf  = await r.arrayBuffer();
        const b64  = _bufToB64(buf);
        const ext  = url.split('.').pop()!.split('?')[0]!.toLowerCase();
        const mime = ({woff2:'font/woff2',woff:'font/woff',
                      otf:'font/opentype',ttf:'font/truetype'} as Record<string, string>)[ext]||'font/woff2';
        return {url, dataUri:`data:${mime};base64,${b64}`};
      })
    );

    /* replace URLs that were successfully fetched */
    for(const r of settled){
      if(r.status==='fulfilled')
        css = css.replaceAll(`"${r.value.url}"`, `"${r.value.dataUri}"`);
    }

    _fontCSS = css;
  }catch(e){
    console.warn('Font prefetch failed — will use print fallback:', e);
    _fontCSS = '';          // empty string = "we tried but failed"
  }
  return _fontCSS;
}
